<template>
  <div v-can:[createPermission]>
    <v-btn to="/faqs/create" color="accent"
      ><v-icon>mdi-plus</v-icon> إنشاء سؤال جديد
    </v-btn>
  </div>
</template>

<script>
import { WRITE_FAQS_PERMISSION } from "@/core/statics/Permissions";
export default {
  data() {
    return {
      createPermission: WRITE_FAQS_PERMISSION,
    };
  },
  methods: {},
};
</script>
